import React, { useContext } from 'react';
import Helmet from 'react-helmet';
import { SiteContext } from './Layout';

const Dochead = ({
  title,
  siteName,
  description,
  pageImage,
  metaName,
  metaContent,
  path,
}) => {
  const {
    siteMeta: {
      siteMetadata: { siteUrl, environment },
    },
  } = useContext(SiteContext);

  return (
    <Helmet
      title={title ? `${title} | ${siteName}` : `${siteName}`}
      meta={[
        { name: 'description', content: description },
        { property: 'og:description', content: description },
        { property: 'og:type', content: 'website' },
        {
          property: 'og:title',
          content: title ? `${title} | ${siteName}` : `${siteName}`,
        },
        { property: 'og:site_name', content: siteName },
        {
          property: 'og:url',
          content: `${siteUrl}${path !== '/' ? `/${path}` : ''}`,
        },
        { property: 'og:image', content: pageImage },
        { property: 'og:image:secure_url', content: pageImage },
        { name: metaName, content: metaContent },
      ]}
      link={[
        {
          rel: 'stylesheet',
          type: 'text/css',
          href: 'https://cloud.typography.com/6906332/6742212/css/fonts.css',
        },
        {
          rel: 'stylesheet',
          href:
            'https://fonts.googleapis.com/css2?family=Rokkitt:wght@100;800&display=swap',
        },
      ]}
    >
      <html lang="en" />
    </Helmet>
  );
};

export default Dochead;
